module.exports = __webpack_public_path__ + "static/media/cargo-thumbnail.6d1cdabf.png";